import { Mapper } from "../../../../base/utils/mapper";
import { IpModel } from "../../../../domain/models/thirdparty/ip.model";
import { IpEntity } from "../entities/ip.entity";

export class IpImplementationRepositoryMapper extends Mapper<IpEntity, IpModel> {
    mapFrom(param: IpEntity): IpModel {
        return {
            ip: param.ip
        };
    }
    mapTo(param: IpModel): IpEntity {
        return {
            ip: param.ip,
        }
    }
}